"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxControl = exports.TextControl = exports.Control = exports.Form = void 0;
/**
 * Форма
 */
class Form {
    /**
     * Конструктор
     */
    constructor(controls) {
        this.controls = controls;
    }
    /**
     * Возвращает элемент формы
     */
    get(control) {
        return this.controls[control] || null;
    }
    /**
     * Проверяет валидность формы
     */
    isValid() {
        return !Object.keys(this.controls).some((controlKey) => !!this.controls[controlKey].getError());
    }
    /**
     * Возвращает значения формы
     */
    getValue() {
        return Object.keys(this.controls).reduce((carry, control) => {
            carry[control] = this.controls[control].getValue();
            return carry;
        }, {});
    }
    /**
     * Устанавливает ошибки
     */
    setErrors(errors) {
        Object.keys(errors).forEach((control) => {
            const c = this.controls[control];
            if (c) {
                c.setError(errors[control]);
            }
        });
    }
    /**
     * Сбрасывает ошибки
     */
    resetErrors() {
        Object.keys(this.controls).forEach((controlKey) => {
            const c = this.controls[controlKey];
            c.resetError();
        });
    }
    /**
     * Обновляет значения формы
     */
    patchValue(values) {
        const formKeys = Object.keys(this.controls);
        formKeys.forEach((key) => {
            if (values[key] === undefined) {
                return;
            }
            this.controls[key].setValue(values[key]);
        });
    }
}
exports.Form = Form;
class Control {
    /**
     * Конструктор
     */
    constructor(defaultValue) {
        /**
         * Ошибка
         */
        this.error = '';
        /**
         * Обратные вызовы при изменении значения
         */
        this.callbacks = [];
        /**
         * Обратные вызовы при появлении ошибок
         */
        this.errorCallbacks = [];
        this.value = defaultValue;
    }
    /**
     * Устанавливает значение
     */
    setValue(value) {
        this.value = value;
        this.callbacks.forEach((callback) => {
            callback(value);
        });
    }
    /**
     * Возвращает значение
     */
    getValue() {
        return this.value;
    }
    /**
     * Устанавливает ошибку
     */
    setError(error) {
        this.error = error;
        this.errorCallbacks.forEach((callback) => {
            callback(this.error);
        });
    }
    /**
     * Возвращает ошибку
     */
    getError() {
        return this.error;
    }
    /**
     * Сбрасывает ошибку
     */
    resetError() {
        this.setError('');
    }
    /**
     * Регистрирует обратный вызов на изменение значения
     */
    registerOnChange(fn) {
        this.callbacks.push(fn);
    }
    /**
     * Регистрирует обратный вызов на изменение состояния ошибки
     */
    registerOnError(fn) {
        this.errorCallbacks.push(fn);
    }
}
exports.Control = Control;
/**
 * Текстовый элемент формы
 */
class TextControl extends Control {
}
exports.TextControl = TextControl;
/**
 * Булевый элемент формы
 */
class CheckboxControl extends Control {
}
exports.CheckboxControl = CheckboxControl;
